import React, { Component } from 'react';
import { Route, Switch } from "react-router-dom";
import { paths } from './portal.router.config';
import LandingPage from './release/pages/landing-page/LandingPage'
import LoginPage from './release/pages/login/Login';
import LoginEmailPage from './release/pages/login-email/LoginEmail';
import RegisterPage from './release/pages/register/Register';
import RegisterEmailPage from './release/pages/register-email/RegisterEmail';
import HomePage from './release/pages/home/Home'
import OffersPage from './release/pages/offers/Offers'
import OrdersPage from './release/pages/orders/OrderMainPageController'
import PrecheckRoute from './release/services/permission'
import MyProfilePage from './release/pages/my-profile/MyProfile'
import MoreInfoPage from './release/pages/more-info/MoreInfo';
import ReferFriendPage from './release/pages/refer-friend/ReferFriend';
import NotificationsPage from './release/pages/notifications/Notifications';
import TermAndConditionsPage from './release/pages/more-info/TermAndConditionsPage';
import PrivacyPolicyPage from './release/pages/more-info/PrivacyPolicyPage';
import ForgotPasswordPage from './release/pages/forgot-password/ForgotPasswordController';
import { custom_page } from './portal.custom.page.config';
import IdentifyPage from './release/pages/identify/IdentifyController';
import MapPage from './release/pages/map/MapController';
import Addresses from './release/pages/addresses/Addresses';
import ProcessOrderSecure from './release/pages/orders/ProcessOrderSecure';
import ProcessTopupSecure from './release/pages/topup-wallet/ProcessTopupSecure';
import ProcessAddCardSecure from './release/pages/order-cards/ProcessAddCardSecure';
import SubcriptonsPage from './release/pages/subcriptions/Subcriptions';
import OnlineShopPage from './release/pages/online-shop/OnlineShop';
import PaymayaTopUpResult from './release/pages/topup-wallet/PaymayaTopUpResult';
import VNPayProcessOrder from './release/pages/orders/VNPayProcessOrder';
import FACResult from './release/pages/orders/FACResult';
import InvoiceController from './release/pages/invoice/InvoiceController';
import RegisterExistingController from './release/pages/register/RegisterExistingController';
import ServiceRequestsPage from './release/pages/service-requests/ServiceRequestsController';
import { domainName } from './portal.config';
import ProcessPayment from './release/pages/invoice/ProcessPayment';
import WalletController from './release/pages/wallet/WalletController';
import ProcessTopup from './release/pages/topup-wallet/ProcessTopup';

var LandingCompnent = custom_page.landing ? custom_page.landing : LandingPage;
var HomeComponent = custom_page.home ? custom_page.home : HomePage;
var LoginComponent = custom_page.login ? custom_page.login : LoginPage;
var RegisterCompnent = custom_page.register ? custom_page.register : RegisterPage;
var IdentifyComponent = custom_page.identify ? custom_page.identify : IdentifyPage;
class Routers extends Component {
    render() {
        const { config } = this.props
        //console.log('config=',config)
        return (
            <Switch>
                {/* {<Route exact path={paths.offers} component={OfferItems}/> } */}
                <PrecheckRoute exact path={'/'} component={HomeComponent} />
                <PrecheckRoute exact path={paths.home} component={HomeComponent} />
                <PrecheckRoute path={paths.map} component={MapPage} />
                <PrecheckRoute path={paths.offers} component={OffersPage} />
                <PrecheckRoute path={paths.orders} component={OrdersPage} />
                <PrecheckRoute path={paths.myProfile} component={MyProfilePage} />
                <PrecheckRoute path={paths.moreInfo} component={MoreInfoPage} />
                <PrecheckRoute path={paths.referFriend} component={ReferFriendPage} />
                <PrecheckRoute path={paths.notifications} component={NotificationsPage} />
                <PrecheckRoute path={paths.addressBook} component={Addresses} />
                <PrecheckRoute path={paths.process_order} component={ProcessOrderSecure} />
                <PrecheckRoute path={paths.process_topup} component={ProcessTopupSecure} />
                <PrecheckRoute path={paths.process_addcard} component={ProcessAddCardSecure} />
                <PrecheckRoute path={paths.subcriptions} component={SubcriptonsPage} />
                <PrecheckRoute path={paths.online_shop} component={OnlineShopPage} />
                {/* <Route path={paths.register} component={config && config.auth_support && (config.auth_support.email_password || config.auth_support.email_otp) ? RegisterEmailPage : RegisterCompnent} /> */}
                <Route path={paths.login} component={config && config.auth_support && (config.auth_support.email_password || config.auth_support.email_otp) ? LoginEmailPage : LoginComponent} />
                <Route path={paths.landingPage} component={LandingCompnent} />
                <Route path={paths.termConditions} component={TermAndConditionsPage} />
                <Route path={paths.privacyPolicy} component={PrivacyPolicyPage} />
                <Route path={paths.forgotPassword} component={ForgotPasswordPage} />
                <Route path={paths.identify} component={IdentifyComponent} />
                <PrecheckRoute path={paths.paymaya_redirect_url_success} component={PaymayaTopUpResult} />
                <PrecheckRoute path={paths.paymaya_redirect_url_failure} component={PaymayaTopUpResult} />
                <PrecheckRoute path={paths.paymaya_redirect_url_dropout} component={PaymayaTopUpResult} />
                <PrecheckRoute path={paths.vnpay_order} component={VNPayProcessOrder} />
                <PrecheckRoute path={paths.fac_result} component={FACResult} />
                <PrecheckRoute path={paths.invoice} component={InvoiceController} />
                <PrecheckRoute path={paths.wallet} component={WalletController} />
                <Route path={paths.register} component={RegisterExistingController} />
                <PrecheckRoute path={paths.process_payment} component={ProcessPayment} />
                <PrecheckRoute path={paths.new_process_topup} component={ProcessTopup} />
                {domainName == 'airlink' && <PrecheckRoute path={paths.service_requests} component={ServiceRequestsPage} />}
            </Switch>
        );
    }
}
export default Routers;
